import React, { PropsWithChildren } from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import {
  type ForegroundPushNotification,
  isInReactNativeWebView,
  usePushNotifications,
} from "@/hooks/usePushNotifications";
import DialogComponent from "@/lib/components/dialog";
import { useInternationalization } from "@/lib/contexts/internationalization";
import { useAuthenticationComponent } from "./authentication-component.hook.context.lib";
import { AuthenticationContext } from "./authentication.context.lib";

export const AuthenticationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [foregroundPush, setForegroundPush] = React.useState<ForegroundPushNotification | null>(
    null
  );
  const { t } = useInternationalization();
  const {
    loadingToken,
    userName,
    role,
    getUser,
    removeUser,
    refreshUser,
    alias,
    name,
    isCustomerPrimary,
    user,
  } = useAuthenticationComponent();

  usePushNotifications(!!userName, setForegroundPush);

  return (
    <AuthenticationContext.Provider
      value={{
        role,
        userName,
        getUser,
        removeUser,
        refreshUser,
        alias,
        name,
        isCustomerPrimary,
        user,
      }}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadingToken}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {!loadingToken && children}
      {!isInReactNativeWebView && (
        <DialogComponent
          isOpen={!!foregroundPush}
          handleClose={() => setForegroundPush(null)}
          handleClick={() => foregroundPush?.open()}
          texts={{
            title: foregroundPush?.title ?? "",
            message: foregroundPush?.body ?? "",
            agree: t("pushNotification.openAlerts"),
            cancel: t("pushNotification.cancel"),
          }}
        />
      )}
    </AuthenticationContext.Provider>
  );
};
